var React = require('react');

function Google (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.4085 8.1798H9.99348V12.0495H15.372C15.1401 13.3003 14.4365 14.3583 13.3759 15.0671C12.4795 15.6664 11.3355 16.0208 9.99088 16.0208C7.38762 16.0208 5.18567 14.2619 4.3987 11.8984C4.20065 11.299 4.08599 10.658 4.08599 9.9987C4.08599 9.33941 4.20065 8.69837 4.3987 8.09902C5.18827 5.73811 7.39023 3.97915 9.99348 3.97915C11.4606 3.97915 12.7765 4.48469 13.8137 5.47492L16.6801 2.60586C14.9472 0.990228 12.6879 0 9.99348 0C6.0873 0 2.70749 2.24104 1.06319 5.50879C0.385668 6.85863 0 8.38567 0 10.0013C0 11.6169 0.385668 13.1414 1.06319 14.4912C2.70749 17.759 6.0873 20 9.99348 20C12.6932 20 14.955 19.1036 16.6072 17.5765C18.4964 15.8358 19.5883 13.2717 19.5883 10.2254C19.5883 9.51661 19.5257 8.83648 19.4085 8.1798Z","fill":"white"}));
}

Google.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Google;

Google.default = Google;
